module.exports = __webpack_public_path__ + "img/share.462e6310.svg";